import React, { useContext, useState, useEffect, useRef } from "react";
import { useForm, FormProvider } from "react-hook-form";
import FormInput from "../../../components/FormInput";
import { validationRules } from "../../../utils/validationRules";
import {
  createNriLoan,
  getNriLoanByEmail,
  getNriLoanByMobile,
  getAllCities,
  getAllPincode,
  getAllStates,
  getAllCompanies,
  getAllNriLoanBanks,
  getNriLoanBankList,
  createOrGetCustomer
} from "../../../middleware/backend_hepler";
import { AuthContext } from "../../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SelectInput from "../../../components/SelectInput";
import DropDownInput from "../../../components/DropDownInput";
import { FaTrashAlt } from "react-icons/fa";
import CreateCompanyModal from "../Company/CreateComapnyModal";


const CreateNriForm = () => {
  const { adminId, adminName, isLoggedIn, adminRole } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodenumber, setPincode] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [mobileExists, setMobileExists] = useState(false);
  const [selectedState, setSelectedState] = useState(null);
  const [presentState, setPresentState] = useState(null);
  const [presentCityOptions, setPresentCityOptions] = useState([]);
  const [presentPincodeOptions, setPresentPincodeOptions] = useState([]);
  const [companyLists, setCompanyLists] = useState([]);
  const [bankLists, setBankLists] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [nriLoanBanks, setNriLoanBanks] = useState([]);
  const [files, setFiles] = useState({});
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  const methods = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    handleSubmit,
    setValue,
    trigger,
    formState: { errors, isValid },
    watch,
  } = methods;
  const email = watch("email");
  const mobile = watch("mobile");
  const dob = watch('dob');
  const maritalStatus = watch("marital_status");
  const coApplicantRelationships = watch("co_applicant_relationship");

  const [emailExists, setEmailExists] = useState(false);
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);

  const fileRefs = {
    passport: useRef(null),
    visa: useRef(null),
    salaryslip: useRef(null),
    bank_statement: useRef(null),
    nre_account: useRef(null),
    photo: useRef(null),
    pan: useRef(null),
    aadhar: useRef(null),
  };

  const steps = ["Personal Details", "Income Details", "Upload Documents"];

  const handleStepChange = async (newStep) => {
    if (newStep > activeStep) {
      const isValid = await trigger();
      if (isValid) {
        if (emailExists) {
          toast.error("Email already exists. Please use a different email.");
          return;
        }

        if (mobileExists) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
          return;
        }

        setActiveStep(newStep);
      }
    } else {
      setActiveStep(newStep);
    }
  };

  const checkMobile = async (mobile) => {
    if (mobile) {
      try {
        const data = await getNriLoanByMobile(mobile);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    }
  };

  const fetchCompanies = async () => {
    try {
      const response = await getAllCompanies();
      const companyData = response.data.map((company) => ({
        value: company.company_id,
        label: company.company_name,
      }));
      companyData.sort((a, b) => a.label.localeCompare(b.label));
      setCompanyLists(companyData);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  useEffect(() => {
    if (!selectedCompanyId) return;
    if (
      !selectedCompanyId ||
      (Array.isArray(selectedCompanyId) && selectedCompanyId.length === 0)
    ) return;
    const fetchCompanyByIdWithBanks = async () => {
      try {
        const response = await getAllNriLoanBanks(selectedCompanyId);

        const bankList = response.data.bank_list;

        const formattedBanks = bankList.map((bank) => ({
          value: bank.bank_name,
          label: bank.bank_name,
        }));

        setBankLists(formattedBanks);
      } catch (error) {
        console.error("Error fetching bank:", error);
      }
    };

    fetchCompanyByIdWithBanks();
  }, [selectedCompanyId]);

  useEffect(() => {
    const fetchNriLoanBanks = async () => {
      try {
        const response = await getNriLoanBankList();
        const banksData = response.data.map((bank) => ({
          value: bank.bank_name,
          label: bank.bank_name,
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setNriLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching nri loan banks:", error);
      }
    };
    fetchNriLoanBanks();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setStates(availableStates);
        setFilteredStates(availableStates);
      } catch (error) {
        console.error("Error fetching states data:", error);
      }
    };
    fetchStates();
  }, []);

  const stateOptions = filteredStates.map((state) => ({
    value: state.name,
    label: state.name,
  }));

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const citiesData = await getAllCities();
        citiesData.sort((a, b) => a.name.localeCompare(b.name));
        setCities(citiesData);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, []);

  useEffect(() => {
    const fetchPinCode = async () => {
      try {
        const pincodeData = await getAllPincode();
        setPincode(pincodeData);
      } catch (error) {
        console.error("Error fetching pincodes:", error);
      }
    };
    fetchPinCode();
  }, []);

  useEffect(() => {
    if (!selectedState) {
      setCityOptions([]);
      setPincodeOptions([]);
      return;
    }

    const filteredCities = cities.filter(
      (city) => city.State_name === selectedState
    );

    const cityOptions = filteredCities.map((city) => ({
      value: city.name,
      label: city.name,
    }));

    setCityOptions(cityOptions);

    const filteredPincodes = pincodenumber.filter(
      (pincode) => pincode.state === selectedState.toUpperCase()
    );

    const uniquePincodes = new Set();
    const uniqueOptions = [];

    filteredPincodes.forEach((pincode) => {
      if (!uniquePincodes.has(pincode.pincode)) {
        uniquePincodes.add(pincode.pincode);
        uniqueOptions.push({
          value: pincode.pincode,
          label: pincode.pincode,
        });
      }
    });

    uniqueOptions.sort((a, b) => a.value - b.value);
    setPincodeOptions(uniqueOptions);

    if (!presentState) {
      setPresentCityOptions([]);
      setPresentPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === presentState
      );

      const presentCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setPresentCityOptions(presentCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === presentState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPresentPincodeOptions(uniqueOptions);
    }
  }, [selectedState, presentState, cities, pincodenumber]);

  const checkEmail = async (email) => {
    if (email) {
      try {
        const data = await getNriLoanByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    }
  };

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    if (files.length > 0) {
      setFiles((prev) => ({
        ...prev,
        [name]: files.length > 0 ? files[0] : null,
      }));
    }
  };

  const handleClearFile = (name) => {
    if (fileRefs[name] && fileRefs[name].current) {
      fileRefs[name].current.value = null;
      setFiles((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption?.value || null);
    setValue("state", selectedOption?.value || "");
  };

  const getSelectedStateValue = () => {
    return stateOptions.find((option) => option.value === selectedState);
  };

  const handlePresentStateChange = (selectedOption) => {
    setPresentState(selectedOption?.value || null);
    setValue("present_state", selectedOption?.value || "");
  };

  const getSelectedPresentStateValue = () => {
    return stateOptions.find((option) => option.value === presentState);
  };

  const handleCompanyChange = (selectedOption) => {
    setSelectedCompanyId(selectedOption.value || null);
    setCompanyName("company_name", selectedOption.label || "")
    setValue("company_name", selectedOption.label || "");
  };

  const getSelectedCompanyValue = () => {
    return companyLists.find((option) => option.label === companyName);
  };

  const handleCompanyButtonClick = () => {
    setIsViewModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsViewModalOpen(false);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const mobile = localStorage.getItem("verifiedMobile");
    const name = data.name;

    try {
      if (!isLoggedIn) {
        // Not logged in: create or get customer
        let adminId;
        let adminName = name;

        try {
          const customerResponse = await createOrGetCustomer({ mobile, name });
          adminId = customerResponse.adminId;
          adminName = customerResponse.name || name;
          // toast.info(customerResponse.isNew ? "Customer created successfully!" : "Customer already exists!");
        } catch (err) {
          throw err;
        }

        // Set created_by and created_id for the home loan
        data.created_by = adminName;
        data.created_id = adminId;
        data.status = data.status || "open";
        data.assigned_to = data.assigned_to || "";

      } else {
        data.created_by = adminName;
        data.created_id = adminId;
      }

      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        if (
          key === "passport" ||
          key === "visa" ||
          key === "salaryslip" ||
          key === "bank_statement" ||
          key === "nre_account" ||
          key === "photo" ||
          key === "pan" ||
          key === "aadhar"
        ) {
          formData.append(key, data[key][0]);
        } else {
          formData.append(key, data[key]);
        }
      });

      const response = await createNriLoan(formData);
      toast.success("NRI loan created successfully!");
      setTimeout(() => {
        navigate(isLoggedIn ? "/nriloanlist" : "/");
      }, 2000);

    } catch (error) {
      setLoading(false);
      const errorMessage = error.response?.data?.message;
      console.error("Error submitting NRI loan:", errorMessage || error);
      toast.error("Failed to submit loan application. Please try again.");
    }
  };

  React.useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  React.useEffect(() => {
    if (mobile) {
      checkMobile(mobile);
    }
  }, [mobile]);

  React.useEffect(() => {
    if (dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      if (age >= 0) {
        setValue('age', age);
      } else {
        setValue('age', '');
      }
    }
  }, [dob, setValue]);

  const handleGoBack = () => {
    if (isLoggedIn) {
      navigate("/nriloanlist");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="container">
      {activeStep === 0 && (
        <div className="edit-back-icon">
          <div className="edit-back-text" onClick={handleGoBack}>
            &lt; Go Back
          </div>
        </div>
      )}
      <h2 className="my-4">NRI Loan</h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="form-group">
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="name"
                      label="Name"
                      registerOptions={validationRules.name}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="dob"
                      label="Date of Birth"
                      type="date"
                      registerOptions={{
                        required: "Date of Birth is required",
                        validate: {
                          isOldEnough: (value) => {
                            const today = new Date();
                            const minAgeDate = new Date();
                            const maxAgeDate = new Date();
                            minAgeDate.setFullYear(today.getFullYear() - 21);
                            maxAgeDate.setFullYear(today.getFullYear() - 58);
                            return (
                              (new Date(value) <= minAgeDate &&
                                new Date(value) >= maxAgeDate) ||
                              "Choose age from 21 to 58"
                            );
                          },
                          isNotFutureDate: (value) => {
                            return (
                              new Date(value) <= new Date() ||
                              "Date of Birth cannot be in the future"
                            );
                          },
                        },
                      }}
                      error={errors.dob?.message}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormInput name="age" label="Age" type="number" readOnly />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="mobile"
                      label="Mobile"
                      type="tel"
                      registerOptions={validationRules.mobile}
                      error={
                        mobileExists
                          ? "Mobile number already exists"
                          : errors.mobile?.message
                      }
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="email"
                      label="Email ID"
                      registerOptions={validationRules.email}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="father_name"
                      label="Father Name"
                      registerOptions={validationRules.father_name}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="mother_name"
                      label="Mother Name"
                      registerOptions={validationRules.mother_name}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="marital_status"
                      label="Marital Status"
                      options={[
                        { value: "Single", label: "Single" },
                        { value: "Married", label: "Married" },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                    />
                  </Col>
                  {maritalStatus === "Married" && (
                    <Col md={6}>
                      <FormInput
                        name="spouse_name"
                        label="Spouse Name"
                        registerOptions={{
                          required: "Spouse Name is required",
                        }}
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <DropDownInput
                      name="residence_type"
                      label="Residence Type"
                      options={[
                        {
                          value: "Own",
                          label: "Own",
                        },
                        { value: "Rent", label: "Rent" },
                      ]}
                      registerOptions={{
                        required: "Residence Type is required",
                      }}
                      error={errors.residence_type?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="location"
                      label="Present Staying Address"
                      registerOptions={{ required: "Address is required" }}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="landmark"
                      label="Landmark"
                      registerOptions={{ required: "Landmark is required" }}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="state"
                      label="State"
                      options={stateOptions}
                      value={getSelectedStateValue()}
                      registerOptions={{ required: "State is required" }}
                      onChange={handleStateChange}
                      error={errors.state?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="city"
                      label="City"
                      options={cityOptions}
                      registerOptions={{ required: "City is required" }}
                      error={errors.city?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="pincode"
                      label="Pincode"
                      options={pincodeOptions}
                      registerOptions={{ required: "Pincode is required" }}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="present_address_adhaar"
                      label="Is your Present Address as per Aadhaar"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{
                        required: "This selection is required",
                      }}
                      error={errors.present_address_adhaar?.message}
                    />
                  </Col>
                  {watch("present_address_adhaar") === "No" && (
                    <>
                      <Col md={6}>
                        <FormInput
                          name="present_address"
                          label="Present Aadhaar Address"
                          registerOptions={{
                            required: "Address is required",
                          }}
                          error={errors.present_address?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="present_state"
                          label="State"e
                          options={stateOptions}
                          value={getSelectedPresentStateValue()}
                          onChange={handlePresentStateChange}
                          registerOptions={{ required: "State is required" }}
                          error={errors.present_state?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="present_city"
                          label="City"
                          options={presentCityOptions}
                          registerOptions={{ required: "City is required" }}
                          error={errors.present_city?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="present_pincode"
                          label="Pincode"
                          options={presentPincodeOptions}
                          registerOptions={{ required: "Pincode is required" }}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="present_landmark"
                          label="Landmark"
                          registerOptions={{ required: "Landmark is required" }}
                          error={errors.present_landmark?.message}
                        />
                      </Col>
                    </>
                  )}
                  <Col md={6}>
                    <DropDownInput
                      name="add_co_applicant"
                      label="Add Co-Applicant"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{
                        required: "Selection is required",
                      }}
                    />
                  </Col>
                </Row>

                {watch("add_co_applicant") === "Yes" && (
                  <div className="sections co-applicant-details-sections">
                    <h4>Co-Applicant Details</h4>
                    <Row>
                      <Col md={6}>
                        <DropDownInput
                          name="co_applicant_relationship"
                          label="Relationship with Applicant"
                          options={[
                            { value: "spouse", label: "Spouse" },
                            { value: "father", label: "Father" },
                            { value: "mother", label: "Mother" },
                            { value: "son", label: "Son" },
                          ]}
                          registerOptions={{
                            required: "Relationship is required",
                          }}
                        />
                      </Col>
                      {coApplicantRelationships === "spouse" && (
                        <Col md={6}>
                          <FormInput
                            name="co_applicant_spouse_name"
                            label="Co-Applicant Spouse Name"
                            registerOptions={{
                              required: "Co-Applicant Spouse Name is required",
                            }}
                          />
                        </Col>
                      )}
                      {coApplicantRelationships === "father" && (
                        <Col md={6}>
                          <FormInput
                            name="co_applicant_fathers_name"
                            label="Co-Applicant Father Name"
                            registerOptions={{
                              required: "Co-Applicant Father Name is required",
                            }}
                          />
                        </Col>
                      )}
                      {coApplicantRelationships === "mother" && (
                        <Col md={6}>
                          <FormInput
                            name="co_applicant_mothers_name"
                            label="Co-Applicant Mother Name"
                            registerOptions={{
                              required: "Co-Applicant Mother Name is required",
                            }}
                          />
                        </Col>
                      )}
                      {coApplicantRelationships === "son" && (
                        <Col md={6}>
                          <FormInput
                            name="co_applicant_son_name"
                            label="Co-Applicant Son Name"
                            registerOptions={{
                              required: "Co-Applicant Son Name is required",
                            }}
                          />
                        </Col>
                      )}
                      <Col md={6}>
                        <FormInput
                          name="co_applicant_mobile"
                          label="Co-Applicant Mobile"
                          type="tel"
                          registerOptions={{
                            required: "Co-Applicant Mobile is required",
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="co_applicant_email"
                          label="Co-Applicant Email"
                          type="email"
                          registerOptions={{
                            required: "Co-Applicant Email is required",
                          }}
                        />
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
            )}

            {activeStep === 1 && (
              <div className="sections loan-details-sections">
                <h4>Income Details</h4>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="required_loan_amount"
                      label="Required Loan Amount"
                      type="number"
                      registerOptions={validationRules.loanAmount}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="existing_emi_amount"
                      label="Existing EMI"
                      type="number"
                      registerOptions={{
                        required: "Existing EMI is required",
                      }}
                      error={errors.existing_emi_amount?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="working_country"
                      label="Working Country"
                      registerOptions={{
                        required: "Working country is required",
                      }}
                      error={errors.working_country?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="company_name"
                      label="Working Company Name"
                      options={companyLists}
                      value={getSelectedCompanyValue()}
                      onChange={handleCompanyChange}
                      addButtonLabel="+ Add Company"
                      onAddButtonClick={handleCompanyButtonClick}
                    />
                  </Col>
                  {watch("company_name") === "Others" && (
                    <Col md={6}>
                      <FormInput
                        name="others_company"
                        label="Other's Company Name"
                      />
                    </Col>
                  )}
                  {isLoggedIn && adminRole !==  "customer" &&
                  (watch("company_name") === "Others" || bankLists.length < 1) &&  (
                    <Col md={6}>
                      <SelectInput
                        name="bank_name"
                        label="Bank Name"
                        options={nriLoanBanks}
                      />
                    </Col>
                  )}
                  {isLoggedIn && adminRole !==  "customer" &&
                  (watch("company_name") !== "Others" && bankLists.length > 0) && (
                    <Col md={6}>
                      <SelectInput
                        name="bank_name"
                        label="Bank Name"
                        options={bankLists}
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <FormInput
                      name="net_salary_indian_rupees"
                      label="Net salary in Indian Rupees"
                      type="number"
                      registerOptions={{ required: "Net salary is required" }}
                      error={errors.net_salary_indian_rupees?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="present_india"
                      label="Are you currently in India?"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="add_reference"
                      label="Add Reference"
                      options={[
                        { value: "Colleague", label: "Colleague" },
                        { value: "Relative", label: "Relative" },
                      ]}
                    />
                  </Col>
                </Row>
                <Row>
                  <h4>Reference Details</h4>
                  <Col md={6}>
                    <FormInput name="reference_name" label="Name" />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="reference_mobile"
                      label="Mobile"
                      type="tel"
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput name="reference_address" label="Address" />
                  </Col>
                  <Col md={6}>
                    <FormInput name="reference_location" label="Location" />
                  </Col>
                </Row>
              </div>
            )}
            {activeStep === 2 && (
              <div className="sections financial-details-sections">
                <h4>Please Upload Clear Copy</h4>
                <div className="form-row">
                  <div className="sections document-upload-sections">
                    <div className="document-upload-group create-document">
                      <div className="document-label-container">
                        <label
                          htmlFor="photo"
                          className="document-label required"
                        >
                          Photo <br/> (Selfie Recommend)

                        </label>
                      </div>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="photo"
                          name="photo"
                          className="form-control-file"
                          {...methods.register("photo", {
                            required: "Photo is required",
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("photo").ref(e);
                            fileRefs.photo.current = e;
                          }}
                        />
                        {files.photo && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("photo")}
                          />
                        )}
                      </div>
                      {errors.photo && (
                        <span className="error-message">
                          {errors.photo.message}
                        </span>
                      )}
                    </div>
                    <div className="document-upload-group create-document">
                      <div className="document-label-container">
                        <label
                          htmlFor="aadhar"
                          className="document-label required"
                        >
                          Aadhaar/eAadhaar
                        </label>
                      </div>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="aadhar"
                          name="aadhar"
                          className="form-control-file"
                          {...methods.register("aadhar", {
                            required: "Aadhaar Card is required",
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("aadhar").ref(e);
                            fileRefs.aadhar.current = e;
                          }}
                        />
                        {files.aadhar && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("aadhar")}
                          />
                        )}
                      </div>
                      {errors.aadhar && (
                        <span className="error-message">
                          {errors.aadhar.message}
                        </span>
                      )}
                    </div>
                    <div className="document-upload-group create-document">
                      <label
                        htmlFor="pan"
                        className="document-label required"
                      >
                        PAN Card
                      </label>
                      <div className="document-file-container">
                        <input
                          id="pan"
                          name="pan"
                          type="file"
                          className="form-control-file"
                          {...methods.register("pan", {
                            required: "PAN Card is required",
                            onChange: (e) => handleFileChange(e), // merge your custom onChange
                          })}
                          ref={(e) => {
                            methods.register("pan").ref(e); // react-hook-form ref
                            fileRefs.pan.current = e;
                          }}
                        />
                        {files.pan && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("pan")}
                          />
                        )}
                      </div>
                      {errors.pan && (
                        <span className="error-message">
                          {errors.pan.message}
                        </span>
                      )}
                    </div>

                    <div className="document-upload-group create-document">
                      <label
                        htmlFor="salaryslip"
                        className="document-label required"
                      >
                        Salary Payslip <br /> (Last 3 Months)
                      </label>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="salaryslip"
                          name="salaryslip"
                          className="form-control-file"
                          {...methods.register("salaryslip", {
                              required: "Salaryslip is required",
                              onChange: (e) => handleFileChange(e),
                            })}
                            ref={(e) => {
                              methods.register("salaryslip").ref(e);
                              fileRefs.salaryslip.current = e;
                            }}
                          />
                          {files.salaryslip && (
                            <FaTrashAlt
                              className="trash-icon"
                              title="Remove file"
                              onClick={() => handleClearFile("salaryslip")}
                            />
                          )}
                        </div>
                      {errors.salaryslip && (
                        <span className="error-message">
                          {errors.salaryslip.message}
                        </span>
                      )}
                    </div>

                    <div className="document-upload-group create-document">
                      <label
                        htmlFor="bank_statement"
                        className="document-label required"
                      >
                        Bank Statement <br /> (Last 6 Months)
                      </label>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="bank_statement"
                          name="bank_statement"
                          className="form-control-file"
                          accept=".pdf"
                          {...methods.register("bank_statement", {
                            required: "Bank Statement is required",
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                              methods.register("bank_statement").ref(e);
                              fileRefs.bank_statement.current = e;
                            }}
                          />
                          {files.bank_statement && (
                            <FaTrashAlt
                              className="trash-icon"
                              title="Remove file"
                              onClick={() => handleClearFile("bank_statement")}
                            />
                          )}
                        </div>
                      <span className="file-upload-message">
                        Upload only PDF files & without password
                      </span>
                      {errors.bank_statement && (
                        <span className="error-message">
                          {errors.bank_statement.message}
                        </span>
                      )}
                    </div>

                    <div className="document-upload-group create-document">
                      <label
                        htmlFor="nre_account"
                        className="document-label required"
                      >
                        NRE/NRO Account
                      </label>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="nre_account"
                          name="nre_account"
                          className="form-control-file"
                          {...methods.register("nre_account", {
                            required: "NRE/NRO Account is required",
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                              methods.register("nre_account").ref(e);
                              fileRefs.nre_account.current = e;
                            }}
                        />
                        {files.nre_account && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("nre_account")}
                          />
                        )}
                      </div>
                      {errors.nre_account && (
                        <span className="error-message">
                          {errors.nre_account.message}
                        </span>
                      )}
                    </div>

                    <div className="document-upload-group create-document">
                      <label
                        htmlFor="passport"
                        className="document-label"
                      >
                        Passport & Visa
                      </label>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="passport"
                          name="passport"
                          className="form-control-file"
                          {...methods.register("passport", {
                            onChange: (e) => handleFileChange(e), // merge your custom onChange
                          })}
                          ref={(e) => {
                            methods.register("passport").ref(e); // react-hook-form ref
                            fileRefs.passport.current = e;
                          }}
                        />
                        {files.passport && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("passport")}
                          />
                        )}
                      </div>
                    </div>

                    <div className="document-upload-group create-document">
                      <label htmlFor="visa" className="document-label">
                        Others
                      </label>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="visa"
                          name="visa"
                          className="form-control-file"
                          {...methods.register("visa", {
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("visa").ref(e);
                            fileRefs.visa.current = e;
                          }}
                        />
                        {files.visa && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("visa")}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="button-container">
            <Row className="mt-4">
              <Col className="text-end">
                {activeStep > 0 && (
                  <Button
                    variant="secondary"
                    onClick={() => handleStepChange(activeStep - 1)}
                    className="custom-back-button"
                  >
                    Go Back
                  </Button>
                )}
                {activeStep < steps.length - 1 && (
                  <Button
                    variant="primary"
                    onClick={() => handleStepChange(activeStep + 1)}
                    className="custom-next-button"
                  >
                    Next Step
                  </Button>
                )}
                {activeStep === steps.length - 1 && (
                  <Button
                    type="submit"
                    variant="primary"
                    className="custom-submit-button"
                  >
                    {loading ? "Processing..." : "Submit"}
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </form>
      </FormProvider>
      <CreateCompanyModal           
        isOpen={isViewModalOpen}
        onClose={handleCloseModal}
        onCompanyCreated={fetchCompanies} 
      />
      <ToastContainer />
    </div>
  );
};

export default CreateNriForm;
